import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from './modules/components/Typography';
import AppAppBar from './modules/views/AppAppBar';
import AppFooter from './modules/views/AppFooter';
import withRoot from './modules/withRoot';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import autoRefreshedExecuteGetUserProfile from './modules/tools/getUserProfileRequest';
import { getUserProfileResponse } from './modules/tools/getUserProfileRequest';
import autoRefreshedExecuteGetDeleteUserProfileWithToken from './modules/tools/getDeleteUserProfileRequest';


function SelfService() {
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [userProfile, setUserProfile] = useState<getUserProfileResponse | null>(null);

    const openConfirmationDialog = () => {
        setIsConfirmationOpen(true);
    };

    const closeConfirmationDialog = () => {
        setIsConfirmationOpen(false);
    };

    const handleDeleteAccount = async () => {
        const accessToken = localStorage.getItem('access_token');
        const deleteUserData = async () => {
            try {
                const response = await autoRefreshedExecuteGetDeleteUserProfileWithToken(accessToken);
            } catch (error) {
                console.error("Error deleting data:", error);
            }
        };
        deleteUserData();
        closeConfirmationDialog();
        window.location.reload();
    };

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token');
        const fetchData = async () => {
            try {
                const response = await autoRefreshedExecuteGetUserProfile(accessToken);
                setUserProfile(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);


    return (
        <React.Fragment>
            <AppAppBar />
            <Container>
                <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography variant="h3" gutterBottom marked="center" align="center">
                        Self Service
                    </Typography>
                    <Card sx={{ mt: 3, width: '50%', minWidth: 400, maxWidth: 1000 }}>
                        {userProfile ? (  // Check if userProfile is not null
                            <React.Fragment>
                                <CardHeader
                                    avatar={
                                        <Avatar sx={{ bgcolor: "#2196f3" }} aria-label="recipe">
                                            <PersonIcon />
                                        </Avatar>
                                    }
                                    titleTypographyProps={{ variant: 'h6', sx: { fontSize: 18 } }}
                                    title={userProfile.username}
                                    subheaderTypographyProps={{ variant: 'body2', sx: { fontSize: 18 } }}
                                    subheader={userProfile.email}
                                />
                                <CardContent>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 16, marginBottom: 1 }}>
                                        <strong>Name:</strong> {userProfile.username}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 16, marginBottom: 1 }}>
                                        <strong>Email:</strong> {userProfile.email}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 16, marginBottom: 1 }}>
                                        <strong>Joined:</strong> {userProfile.date_joined}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: 16, marginBottom: 1 }}>
                                        <strong>Status:</strong> {userProfile.is_active ? 'Active' : ''}
                                    </Typography>
                                </CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 2 }}>
                                    <Button variant="outlined" color="error" onClick={openConfirmationDialog}>
                                        Delete Account
                                    </Button>
                                </Box>
                            </React.Fragment>
                        ) : (
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h4" color="text.secondary" sx={{ fontSize: 16, margin: 4 }}>
                                    Please login
                                </Typography>
                            </CardContent>
                        )}
                    </Card>
                </Box>
            </Container>

            {/* Confirmation Dialog */}
            <Dialog
                open={isConfirmationOpen}
                onClose={closeConfirmationDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Confirm Account Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete your account?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmationDialog} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDeleteAccount} color="error" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <AppFooter />
        </React.Fragment>
    );
}

export default withRoot(SelfService);
